import { useState } from 'react';
import { Dropdown } from 'react-bootstrap';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';

import { getToolbarActions } from '../../../../reducers/toolbarSlice';

const FilterAction = ({ filtersMenu }) => {
	const intl = useIntl();
	const [show, setShow] = useState(false);

	const handleToggle = (isOpen, event, metadata) => {
		setShow(isOpen);
	};

	const closeFilterDropdown = () => setShow(false);
	const filters = filtersMenu(closeFilterDropdown);

	return (
		<div className="m-0">
			<Dropdown show={show} onToggle={handleToggle} autoClose={false}>
				<Dropdown.Toggle as="a" className="secondary-button fs-7 fw-bold">
					{intl.formatMessage({ id: 'GENERAL.FILTERS' })}
				</Dropdown.Toggle>

				<Dropdown.Menu className="menu menu-sub menu-sub-dropdown w-250px w-md-300px" renderOnMount popperConfig={{ strategy: 'fixed' }}>
					{filters}
				</Dropdown.Menu>
			</Dropdown>
		</div>
	);
};

const ToolbarActions = () => {
	const toolbarActions = useSelector(getToolbarActions);

	return (
		<>
			{toolbarActions.map((action) => {
				if (action.type === 'filterAction') {
					return <FilterAction key={action?.id} filtersMenu={action?.filtersMenu} />;
				}
				return (
					<button key={action.id} type="button" className={action?.className} onClick={action.onClick} disabled={action.disabled}>
						{action?.icon}
						{action.label}
					</button>
				);
			})}
		</>
	);
};

export default ToolbarActions;
